import { Building2, Palette, Ruler, Scissors } from 'lucide-react';
import Reveal from '../animation/Reveal';

const serviceIcons = {
  Alterations: Scissors,
  'Dishdasha Tailoring': Ruler,
  'Fabric Guidance': Palette,
  "Men's Tailoring": Building2,
};

function ServiceCard({ service, headingLevel = 'h3', delay = 0 }) {
  const HeadingTag = headingLevel;
  const Icon = serviceIcons[service.title] ?? Ruler;

  return (
    <Reveal as="article" className="service-card" delay={delay} y={22}>
      <span className="service-icon" aria-hidden="true">
        <Icon size={24} strokeWidth={1.8} />
      </span>
      <HeadingTag>{service.title}</HeadingTag>
      <p>{service.text}</p>
    </Reveal>
  );
}

export default ServiceCard;
